import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    API_BASE_URL,
    deleteRequest,
    extractErrorMessage,
    getRequest,
    patchRequest,
    postRequest,
    putRequest,
} from "../../../api";
import {
    getKmsCategoriesFail,
    getKmsCategoriesSuccess,
    getKmsTagsFail,
    getKmsTagsSuccess,
    getKmsTaxonomyOptionsFail,
    getKmsTaxonomyOptionsSuccess,
    setKmsTaxonomyLoading,
    setKmsTaxonomySaving,
} from "../actions/kmsTaxonomyActions";

const getUidHeaderAndToken = () => ({
    uid: sessionStorage.getItem("uid") || localStorage.getItem("uid"),
    token: sessionStorage.getItem("token") || localStorage.getItem("token"),
});

function* refreshTaxonomyCollections() {
    yield put({ type: "GET_KMS_TAXONOMY_OPTIONS_REQUEST" });
    yield put({ type: "GET_KMS_CATEGORIES_REQUEST", payload: { activeOnly: false } });
    yield put({ type: "GET_KMS_TAGS_REQUEST" });
}

export function* getKmsTaxonomyOptionsSaga() {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/options`;

    yield put(setKmsTaxonomyLoading(true));
    try {
        const response = yield call(getRequest, { url, token });
        yield put(getKmsTaxonomyOptionsSuccess(response.data));
    } catch (error) {
        yield put(getKmsTaxonomyOptionsFail(extractErrorMessage(error, "Erreur de chargement de la taxonomie KMS")));
    } finally {
        yield put(setKmsTaxonomyLoading(false));
    }
}

export function* getKmsCategoriesSaga(action) {
    const { token } = getUidHeaderAndToken();
    const activeOnly = action.payload?.activeOnly;
    const query = activeOnly === undefined ? "" : `?activeOnly=${activeOnly}`;
    const url = `${API_BASE_URL}/api/kms/taxonomy/categories${query}`;

    yield put(setKmsTaxonomyLoading(true));
    try {
        const response = yield call(getRequest, { url, token });
        yield put(getKmsCategoriesSuccess(response.data));
    } catch (error) {
        yield put(getKmsCategoriesFail(extractErrorMessage(error, "Erreur de chargement des categories KMS")));
    } finally {
        yield put(setKmsTaxonomyLoading(false));
    }
}

export function* getKmsTagsSaga() {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/tags`;

    yield put(setKmsTaxonomyLoading(true));
    try {
        const response = yield call(getRequest, { url, token });
        yield put(getKmsTagsSuccess(response.data));
    } catch (error) {
        yield put(getKmsTagsFail(extractErrorMessage(error, "Erreur de chargement des tags KMS")));
    } finally {
        yield put(setKmsTaxonomyLoading(false));
    }
}

function* executeMutation(request, successMessage, fallbackErrorMessage) {
    yield put(setKmsTaxonomySaving(true));
    try {
        yield call(request);
        yield* refreshTaxonomyCollections();
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: successMessage,
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        const message = extractErrorMessage(error, fallbackErrorMessage);
        yield put(getKmsCategoriesFail(message));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: message,
            confirmButtonText: "OK",
        });
    } finally {
        yield put(setKmsTaxonomySaving(false));
    }
}

export function* createKmsCategorySaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/categories`;
    yield* executeMutation(
        () => postRequest({ url, data: action.payload, token }),
        "Categorie creee avec succes",
        "Erreur lors de la creation de la categorie"
    );
}

export function* updateKmsCategorySaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/categories/${action.payload.id}`;
    yield* executeMutation(
        () => putRequest({ url, data: action.payload.data, token }),
        "Categorie mise a jour avec succes",
        "Erreur lors de la mise a jour de la categorie"
    );
}

export function* toggleKmsCategoryActiveSaga(action) {
    const { uid, token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/categories/${action.payload.id}/active?active=${action.payload.active}`;
    yield* executeMutation(
        () => patchRequest({ url, data: {}, uid, token }),
        action.payload.active ? "Categorie reactivee" : "Categorie desactivee",
        "Erreur lors du changement de statut de la categorie"
    );
}

export function* deleteKmsCategorySaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/categories/${action.payload.id}`;
    yield* executeMutation(
        () => deleteRequest({ url, token }),
        "Categorie supprimee avec succes",
        "Erreur lors de la suppression de la categorie"
    );
}

export function* createKmsTagSaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/tags`;
    yield* executeMutation(
        () => postRequest({ url, data: action.payload, token }),
        "Tag crée avec succés",
        "Erreur lors de la création du tag"
    );
}

export function* updateKmsTagSaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/tags/${action.payload.id}`;
    yield* executeMutation(
        () => putRequest({ url, data: action.payload.data, token }),
        "Tag mis a jour avec succes",
        "Erreur lors de la mise a jour du tag"
    );
}

export function* deleteKmsTagSaga(action) {
    const { token } = getUidHeaderAndToken();
    const url = `${API_BASE_URL}/api/kms/taxonomy/tags/${action.payload.id}`;
    yield* executeMutation(
        () => deleteRequest({ url, token }),
        "Tag supprime avec succes",
        "Erreur lors de la suppression du tag"
    );
}
